<template>
  <div class="container hero-freemium p-0">
    <div class="hero-video-background">
      <video ref="videoPlayer" loop autoplay muted playsinline></video>
    </div>
    <div class="hero-content">
      <h1 class="title" v-html="$t('freemium.hero.title')"></h1>
      <h2 class="subtitle p-3" v-html="$t('freemium.hero.subtitle')"></h2>
      <router-link
        class="btn btn-danger btn-get-started d-block my-5 mx-auto"
        :to="{ name: 'register' }"
      >
        {{ $t("landing.be_part_of.startTrial") }}
      </router-link>
    </div>
  </div>
</template>

<script>
import Hls from "hls.js";

export default {
  components: {},
  data() {
    return {
      hls: null,
      video: null,
    };
  },
  mounted() {
    this.video = this.$refs.videoPlayer;
    this.video.muted = true; // Required for autoplay on some browsers
    this.video.autoplay = true;

    if (Hls.isSupported()) {
      this.hls = new Hls();
      this.hls.loadSource(
        "https://stream.flixlatino.com/websitepromo/master.m3u8"
      );
      this.hls.attachMedia(this.$refs.videoPlayer);

    } else if (this.video.canPlayType("application/vnd.apple.mpegurl")) {
      this.video.src = "https://stream.flixlatino.com/websitepromo/master.m3u8";
    }
  },
  beforeUnmount() {
    if (this.hls) {
      this.hls.destroy();
    }
  },
};
</script>

<style lang="scss" scoped>
.btn-get-started {
  width: 650px;
  @media screen and (max-device-width: 480px) {
    width: 300px;
  }
}
.hero-freemium {
  max-height: 674px;
  margin-bottom: 60px;
  @media screen and (max-device-width: 480px) {
    max-height: 530px;
  }
}
.hero-video-background {
  position: relative;
  top: 0;
  min-height: 674px;
  @media screen and (max-device-width: 480px) {
    min-height: 530px;
  }
  &:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg, #0c121633 0%, #0c121655 100%);
    z-index: 0;
    border-radius: 64px;
    @media screen and (max-device-width: 480px) {
      border-radius: 2rem;
    }
  }
  video {
    object-fit: cover;
    display: block;
    z-index: -5;
    width: 100%;
    min-height: 674px;
    border-radius: 64px;
    @media screen and (max-device-width: 480px) {
      min-height: 530px;
      border-radius: 2rem;
    }
  }
}
.hero-content {
  position: relative;
  top: -518px;
  .title {
    width: 100%;
    font-size: 80px;
    line-height: 80px;
    text-align: center;
    font-weight: 800;
  }
  .subtitle {
    margin-top: 20px;
    width: 100%;
    font-size: 32px;
    line-height: 32px;
    text-align: center;
    font-weight: 600;
  }
  @media screen and (max-device-width: 480px) {
    top: -280px;
    .title {
      width: 100%;
      font-size: 36px;
      line-height: 36px;
    }
    .subtitle {
      font-size: 16px;
      line-height: 16px;
    }
  }
}
</style>
